import { useTranslation } from "react-i18next";

const Label = (props) => {
    const { i18n } = useTranslation();
    const isNepali = i18n.language === 'np';

    return <span>{isNepali ? props.textNep : props.text}</span>
};

export const getTValue = (i18n, desc, descNep) => i18n.language === 'np' && descNep ? descNep : desc;

export const getTObjectValue = (i18n, obj) => typeof obj === 'string' ? obj : i18n.language === 'np' && obj.descNep ? obj.descNep : obj.descEng;

export default Label;